// NPM Imports
import React from "react";

// Internal Imports
import { RevvGridHeader } from "./Components";
import { GroupedTable, UngroupedTable } from "./Display";

export default class RevvGrid extends React.Component {
  componentDidMount() {
    this._attachResizeElement();
    this._resizeRowAndWidth();
  }

  componentDidUpdate() {
    this._resizeRowAndWidth();
  }

  componentWillUnmount() {
    document.removeEventListener("mousemove", () => {});
    document.removeEventListener("mouseup", () => {});
  }

  _resizeRowAndWidth = () => {
    // Set Header Cell Height
    // const headerHeight = document.getElementsByClassName("rs-header")[0]
    //   .offsetHeight;
    // document.getElementsByClassName(
    //   "rs-header-cell",
    // )[0].style.height = `${headerHeight}px`;
    // document.getElementsByClassName(
    //   "rs-header-viewport",
    // )[0].style.marginLeft = `${pinnedHeaderDivWidth}px`;

    // Array.prototype.forEach.call(
    //   document.getElementsByClassName("rs-body-viewport"),
    //   th => {
    //     th.style.marginLeft = `${pinnedHeaderDivWidth}px`;
    //   },
    // );

    // Set Pinned and Body Parallel Alignment
    const pinnedHeaderDivWidth = document.getElementsByClassName(
      "rs-pinned-left-header",
    )[0].offsetWidth;
    Array.prototype.forEach.call(
      document.getElementsByClassName("rs-pinned-left-body"),
      th => {
        th.style.width = `${pinnedHeaderDivWidth}px`;
      },
    );

    const changedWidths = {};
    // Set Equal Cell Width
    Array.prototype.forEach.call(
      document.getElementsByClassName("rs-header-cell"),
      th => {
        const columnId = th.getAttribute("col-id");
        const width = th.offsetWidth;

        Array.prototype.forEach.call(
          document
            .getElementsByClassName("rs-body")[0]
            .querySelectorAll(`[col-id=${columnId}]`),
          thb => {
            thb.style.width = `${width}px`;
            changedWidths[columnId] = width;
          },
        );
      },
    );

    // Set Equal Cell Heights on Pinned & Scroll Div
    Array.prototype.forEach.call(
      document.getElementsByClassName("rs-pinned-left-body"),
      th => {
        Array.prototype.forEach.call(
          th.getElementsByClassName("rs-row"),
          thb => {
            const rowId = thb.getAttribute("row-id");
            const height = thb.offsetHeight;
            document.querySelectorAll(
              `[row-id="${rowId}"]`,
            )[1].style.height = `${height}px`;
          },
        );
      },
    );
    return changedWidths;
  };

  /* Resize Table header according to requirement */
  _attachResizeElement = () => {
    let thElm;
    let startOffset;
    Array.prototype.forEach.call(
      document.getElementsByClassName("rs-header-cell"),
      th => {
        const isDraggable = JSON.parse(th.getAttribute("col-draggable"));
        if (isDraggable) {
          th.style.position = "relative";
          const grip = document.createElement("div");
          grip.innerHTML = "&nbsp;";
          grip.style.top = 0;
          grip.style.right = 0;
          grip.style.bottom = 0;
          grip.style.width = "5px";
          grip.style.position = "absolute";
          grip.style.cursor = "col-resize";
          grip.addEventListener("mousedown", e => {
            thElm = th;
            startOffset = th.offsetWidth - e.pageX;
          });
          th.appendChild(grip);
        }
      },
    );
    let changedWidths = {};
    document.addEventListener("mousemove", e => {
      if (thElm) {
        const columnId = thElm.getAttribute("col-id");
        const defaultColWidth = JSON.parse(thElm.getAttribute("col-minWidth"));
        const columns = document.querySelectorAll(`[col-id=${columnId}]`);
        columns.forEach(col => {
          const width = `${startOffset + e.pageX}`;
          if (width >= defaultColWidth) col.style.width = `${width}px`;
        });
        changedWidths = this._resizeRowAndWidth();
      }
    });
    document.addEventListener("mouseup", () => {
      // Update Redux with the changed lengths. Not storing this anywhere for react to do less storage in state etc.
      if (thElm !== undefined) {
        this.props.applyColumnWidth(changedWidths);
      }
      thElm = undefined;
    });
  };

  _onCellValueChanged = (rowIndex, value, row, columnData) => {
    const oldValue = row.rowData[columnData.field].cellData;
    const newValue = value;
    if (this.props.onCellValueChanged && oldValue !== newValue) {
      // Update the cell value & pass the updated value as callback to component
      row.rowData[columnData.field].cellData = value;
      this.props.onCellValueChanged({
        columnData,
        row,
        rowIndex,
        oldValue,
        newValue,
      });
    }
  };

  _decideGridView = ({ columns, pinnedColumns, rows }) => {
    if (this.props.groupBy) {
      return (
        <GroupedTable
          columns={columns}
          currencySymbol={this.props.currencySymbol}
          deleteRow={this.props.deleteRow}
          discount={this.props.discount}
          groupBy={this.props.groupBy}
          onCellValueChanged={this._onCellValueChanged}
          onUpdatedDiscountValue={this.props.onUpdatedDiscountValue}
          pinnedColumns={pinnedColumns}
          pricingPopUp={this.props.pricingPopUp}
          readOnly={this.props.readOnly}
          rows={rows}
        />
      );
    }
    return (
      <UngroupedTable
        columns={columns}
        currencySymbol={this.props.currencySymbol}
        deleteRow={this.props.deleteRow}
        discount={this.props.discount}
        onCellValueChanged={this._onCellValueChanged}
        pinnedColumns={pinnedColumns}
        pricingPopUp={this.props.pricingPopUp}
        readOnly={this.props.readOnly}
        rows={rows}
      />
    );
  };

  render() {
    const { columnData, rowData, columnWidth } = this.props;
    const visibleColumns = columnData.filter(col => !col.visible);
    let pinnedColumns = visibleColumns.filter(col => col.pinned);
    let columns = visibleColumns.filter(col => !col.pinned);
    const rows = rowData.map(row => row);

    if (columnWidth !== undefined && columnWidth !== null) {
      columns = columns.map(col => {
        if (col.field in columnWidth) {
          col.width = columnWidth[col.field];
        }
        return col;
      });

      pinnedColumns = pinnedColumns.map(col => {
        if (col.field in columnWidth) {
          col.width = columnWidth[col.field];
        }
        return col;
      });
    }

    return (
      <div className="rs-root-wrapper">
        <div className="rs-root">
          <div className="rs-header">
            <div className="rs-pinned-left-header">
              {pinnedColumns.map(col => (
                <RevvGridHeader
                  col={col}
                  key={col.field}
                  sortData={this.props.sortData}
                />
              ))}
            </div>
            <div className="rs-header-viewport">
              {columns.map(col => (
                <RevvGridHeader
                  col={col}
                  key={col.field}
                  sortData={this.props.sortData}
                />
              ))}
            </div>
          </div>
          <div className="rs-body">
            {this._decideGridView({ columns, pinnedColumns, rows })}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/commonComponents/RevvGrid/RevvGrid.js